export default __webpack_public_path__ + "static/media/homepage_slider5.a6acef40.webp";